import React, { useEffect } from 'react'
import { LogBox } from 'react-native'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import { ApplicationProvider, IconRegistry } from '@ui-kitten/components'
import { EvaIconsPack } from '@ui-kitten/eva-icons'
import FlashMessage from "react-native-flash-message"
import { QueryClient, QueryClientProvider } from 'react-query'
import AlignCenter from '../components/AlignCenter'

import { appMappings, appThemes } from './app-theming'
import { AppIconsPack } from './app-icons-pack'
import { StatusBar } from '../components/status-bar.component'
import { Navigation } from '../navigation'
import { Mapping, Theme, Theming } from '../services/theme.service'
import useCachedResources from '../hooks/useCachedResources'
import '@expo/match-media'
//import useColorScheme from '../hooks/useColorScheme'
import Colors from '../constants/Colors'

LogBox.ignoreLogs(['Setting a timer'])

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false
    },
  },
})


const App: React.FC<{ mapping: Mapping, theme: Theme }> = ({ mapping, theme }) => {

  const isLoadingComplete = useCachedResources()
//  const colorScheme = useColorScheme()

  const [mappingContext, currentMapping] = Theming.useMapping(appMappings, mapping)
  const [themeContext, currentTheme] = Theming.useTheming(appThemes, mapping, theme)


  if (!isLoadingComplete) {
    return null
  } else {
    return (
      <>
        <IconRegistry icons={[EvaIconsPack, AppIconsPack]} />
          <ApplicationProvider {...currentMapping} theme={currentTheme}>
            <Theming.MappingContext.Provider value={mappingContext}>
              <Theming.ThemeContext.Provider value={themeContext}>
                <SafeAreaProvider>
                  <StatusBar barStyle="dark-content" backgroundColor="#d5d0d0" />
                    <QueryClientProvider client={queryClient}>
                          <Navigation />
                    </QueryClientProvider>
                    <FlashMessage position="top" autoHide />
                </SafeAreaProvider>
              </Theming.ThemeContext.Provider>
            </Theming.MappingContext.Provider>
          </ApplicationProvider>
      </>
    )
  }
}

export default (): React.ReactElement => (
  <App mapping='eva' theme='light' />
)

